export function formatCell(cell: any): string {
  const type = typeof cell;
  if (type === 'undefined') {
    return '';
  }

  const s = String(cell);

  let processed = s.replaceAll(
    /* eslint unicorn/prefer-string-replace-all: "off"
       ----------
       The rule objects to /"/g and wants to replace it with ". (presumably it
       means '"',
       which seems off its reservation because we're already using replaceAll.
    */
    /"/g,
    '""',
  );

  if (processed.search(/[",\n]/g) >= 0) {
    processed = `"${processed}"`;
  }

  return processed;
}
